import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';

import { getData } from '../utils/apiUtils';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import BorderColorIcon from '@material-ui/icons/BorderColor';

import moment from 'moment';

import apiFetch from '../utils/apiUtils';
import EnhancedTextInput from '../components/EnhancedTextInput';
import AddUserCard from '../components/AddUserCard';
import HistoricData from '../components/HistoricData';
import { DropdownContext, PermissionsContext, ErrorContext, NotificationContext, InitiativeStatus } from "../utils/constants";
import { canEditInitiative, isTo, isWsl } from "../utils/initiatives";
import CommentDialog from '../components/CommentDialog';
import InformationBox from '../components/InformationBox';
import { Typography } from '@material-ui/core';
import '@fontsource/inter';

const useStyles = makeStyles(() => ({
  h1: {
    marginBottom: '5px'
  },
  commandText: {
    marginTop: '2rem',
    fontSize: '20px'
  },
  main: {
    width: '100%',
  },
  details: {
    paddingRight: '17%',
    paddingLeft: '17%',
    paddingTop: '2rem',
    width: '100%'
  },

  inputStyle: {
    width: '100%',
    border: '1px solid #ced4da',
    padding: '10px 12px',
    fontSize: '16px',
    transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    backgroundColor: 'white',
    marginBottom: '1.5rem'
  },
  usersBox: {
    paddingTop: '2rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  statusComments: {
    width: '200px',
  },
  holdCancelCommentSpan: {
    width: '100%',
    border: '1px solid #ced4da',
    padding: '10px 12px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    display: 'inline-block',
    borderRadius: '4px',
  },
  holdCancelCommentLabelLeft: {
    width: '100%',
    display: 'inline-block',
  },
  holdCancelEditButtonSpan:
  {
    float: 'right',
    position: 'relative',
    left: '15px',
    top: '-8px',
    display: 'inline-block',
    height: '0px',
    width: '0px',
  },
  hideEditButton: {
    visibility: 'hidden',
  },
  pencilButton: {
    margin: '0px 0px 0px 0px'
  },
  disableOK: {
    disabled: 'tr'
  }

}));

const info_initiative_type = 'New Value: Initiatives that create value beyond what was previously achieved \nRevenue Replacement: Initiatives that ensure existing value is sustained \nRisk Avoidance: Initiatives that avoid risk of future costs \nZero-dollar: Efficiency initiatives improving the way we operate or run the business';
const info_benefits_budgeted = 'Are the benefits of this initiative included in the budget? If unsure, reach out to your leader.';
const info_costs_budgeted = 'Are the costs for this initiative included in the budget? If unsure, reach out to your leader.';
const info_initiative_team = 'A maximum of 6 people can be added to your initiative team';

export default function InitiativeDetails() {
  const classes = useStyles();
  const params = useParams();
  const { triggerError } = useContext(ErrorContext);
  const notification = useContext(NotificationContext);

  useEffect(() => {
    document.title = 'Rise by TransAlta Initiative Details';
  }, []);

  // State
  const [initiativeCard, setInitiativeCard] = useState({
    id: '',
    initiative_name: '',
    confidential: '',
    workstream_id: '',
    benefits_budgeted: '',
    costs_budgeted: '',
    classification: '',
    status: '',
    status_id: '',
    hold_cancel_comment: '',
    hold_cancel_time: '',
    type_id: '',
    risk_label_id: '',
    risk_label_comment_time: '',
    risk_label_comment: ''
  });

  const [initiativeName, setInitiativeName] = useState([]);
  const [workstreamList, setWorkstreamList] = useState([]);
  const [initiativeStatusList, setInitiativeStatusList] = useState([]);
  const [initiativeTeam, setInitiativeTeam] = useState([]);
  const dropdowns = useContext(DropdownContext).dropdowns;
  const [openOnHoldCommentDialog, setOpenOnHoldCommentDialog] = React.useState(false);
  const [onHoldOrCancelledField, setOnHoldOrCancelledField] = React.useState(false);
  const [holdCancelComment, setHoldCancelComment] = useState([]);
  const [selectedStatusID, setSelectedStatusID] = useState([]);
  const [calculatedStatusID, setCalculatedStatusID] = useState(0);
  const [canSaveHoldCancelComment, setCanSaveHoldCancelComment] = useState(false);
  const [riskLabelComment, setRiskLabelComment] = useState();
  const [openRiskLabelCommentDialog, setOpenRiskLabelCommentDialog] = React.useState(false);
  const [canSaveRiskLabelComment, setCanSaveRiskLabelComment] = useState(false);
  const [selectedRiskLabelID, setSelectedRiskLabelID] = useState(0);
  const [riskCommentText, setRiskCommentText] = useState('');
  const [showRiskComment, setShowRiskComment] = useState(false);
  const [holdCancelCommentText, setHoldCancelCommentText] = useState('');

  const riskLabelOptions = Object.keys(dropdowns['RiskLabel'] || {}).map(key => ({
    value: dropdowns['RiskLabel'][key],
    key
  }));

  const { isAdmin } = useContext(PermissionsContext);

  const updateCalculatedStatusID = (status_id) => {
    const onHoldStatus = initiativeStatusList.filter(s => s.status === InitiativeStatus.ON_HOLD)[0];
    const cancelledStatus = initiativeStatusList.filter(s => s.status === InitiativeStatus.CANCELLED)[0];
    setCalculatedStatusID((initiativeStatusList.length > 0 && (status_id === onHoldStatus.id || status_id === cancelledStatus.id)) ? status_id : 0)
  }

  const onError = () => triggerError({
    title: 'Communication Error',
    description: 'We were unable to read your initiative data from the server. Please try again.',
    onRetry: () => window.location.reload(),
  });

  const refreshData = () => {
    getData('/generaldata/workstreams',
      (list) => {
        setWorkstreamList(list.filter(l => !l.is_disabled));
      }, onError);
    getData('/initiatives/initiative_statuses', setInitiativeStatusList, onError);
    getData('/initiatives/' + params.id, handleInitiativeCardGet, onError);
    getData('/initiatives/' + params.id + '/team', setInitiativeTeam, onError);
  };

  useEffect(() => {
    updateCalculatedStatusID(initiativeCard.status_id);
    refreshInitiativeCard();
  }, [initiativeStatusList], [initiativeCard]);

  useEffect(() => {
    getData('/initiatives/initiative_statuses', setInitiativeStatusList, onError);
  }, []);

  useEffect(() => {
    refreshData();
  }, [params.id]);

  useEffect(() => {
    if (notification && notification.initiativeId === params.id) {
      refreshData();
    }
  }, [notification]);

  const refreshInitiativeTeam = () => {
    getData('/initiatives/' + params.id + '/team', setInitiativeTeam, onError);
  };

  const refreshInitiativeCard = () => {
    getData('/initiatives/' + params.id, handleInitiativeCardGet, onError);
  };

  // Methods
  const handleInitiativeCardGet = (data) => {
    if (!data.costs_budgeted) {
      data.costs_budgeted = '';
    }
    if (!data.benefits_budgeted) {
      data.benefits_budgeted = '';
    }
    setInitiativeCard(data);
    setInitiativeName(data.initiative_name);
    setHoldCancelComment(data.hold_cancel_comment);
    setSelectedStatusID(data.status_id);
    setRiskLabelComment(data.risk_label_comment);
    setSelectedRiskLabelID(data.risk_label_id);
    updateCalculatedStatusID(data.status_id);
    setShowRiskComment(!!data.risk_label_comment);
    setRiskCommentText(data.risk_label_comment ? `${moment(data.risk_label_comment_time).format('MM/DD/YYYY HH:mm')} - ${data.risk_label_comment}` : '');
    setHoldCancelCommentText(data.hold_cancel_comment ? `${moment(data.hold_cancel_time).format('MM/DD/YYYY HH:mm')} - ${data.hold_cancel_comment}` : '');

    if (InitiativeStatus.CANCELLED === data.status || InitiativeStatus.ON_HOLD === data.status) {
      setOnHoldOrCancelledField(true);
    }

  };

  const handleFieldChange = (field, value, callback) => {
    const url = field === 'status_id' ? '/initiatives/updatestatus' : '/initiatives/updatefield';
    apiFetch(url, 'PATCH',
      JSON.stringify({ id: params.id, field, value }),
      (results) => {
        const newInitiative = Object.assign({}, initiativeCard);
        newInitiative[field] = value;
        setInitiativeCard(newInitiative);
        if (callback) { callback(); }
        if (field === 'status_id') {
          updateCalculatedStatusID(value);
        }
      },
      () => triggerError({
        title: 'Update Error',
        description: `We were unable to update field=${field} with value=${value}. Please try again.`,
        onRetry: handleFieldChange.bind(null, field, value)
      }));
  };

  const changeInitiativeName = (event) => {
    setInitiativeName(event);
  }

  const handleStatusChange = (field) => (event) => {
    const statusValue = initiativeStatusList.filter(s => s.id === event.target.value)[0];

    if (statusValue && (InitiativeStatus.CANCELLED === statusValue.status || InitiativeStatus.ON_HOLD === statusValue.status)) {
      setOpenOnHoldCommentDialog(true);
      setSelectedStatusID(event.target.value);
    } else {
      setOnHoldOrCancelledField(false);
      handleFieldChange(field, event.target.value);
      if (statusValue && statusValue.shortName === "OnTrack") {
        handleFieldChange('hold_cancel_comment', "NULL");
        setHoldCancelComment("");
      }
    }
  };

  const handleRiskLabelChange = () => (event) => {
    const newValue = event.target.value;
    if (newValue !== initiativeCard.risk_label_id) {
      setSelectedRiskLabelID(newValue);
      if (riskLabelOptions.find(o => o.key === newValue).value !== 'Low') {
        setOpenRiskLabelCommentDialog(true);
      }

      else {
        handleFieldChange('risk_label_id', newValue);
      }
    }
  };

  const handleChange = (field) => (event) => {
    handleFieldChange(field, event.target.value);
  };

  const handleDialogCancel = (field) => () => {
    if (field === 'hold_cancel_comment') {
      setSelectedStatusID(initiativeCard.status_id);
      const statusValue = initiativeStatusList.filter(s => s.id === initiativeCard.status_id)[0];
      if (statusValue && (InitiativeStatus.CANCELLED === statusValue.status && InitiativeStatus.ON_HOLD === statusValue.status)) {
        setOnHoldOrCancelledField(false);
      }

      setOpenOnHoldCommentDialog(false);
      setCanSaveHoldCancelComment(false);
      setHoldCancelComment(initiativeCard.hold_cancel_comment);
    }

    if (field === 'risk_label_comment') {
      setOpenRiskLabelCommentDialog(false);
      setCanSaveRiskLabelComment(false);
      setRiskLabelComment(initiativeCard.risk_label_comment);
    }

  };

  const handleDialogOK = (field) => () => {
    if (field === 'hold_cancel_comment') {
      handleFieldChange(field, holdCancelComment, () => { handleFieldChange('status_id', selectedStatusID, () => { refreshInitiativeCard(); }); });
      setOpenOnHoldCommentDialog(false);
    }

    if (field === 'risk_label_comment') {
      handleFieldChange(field, riskLabelComment, () => { handleFieldChange('risk_label_id', selectedRiskLabelID, () => { refreshInitiativeCard(); }); });
      setOpenRiskLabelCommentDialog(false);
    }
  };

  const handleDialogTextChanged = (field) => (comment) => {
    if (field === 'hold_cancel_comment') {
      if (comment && comment !== holdCancelComment) {
        setHoldCancelComment(comment);
        setCanSaveHoldCancelComment(true);
      }
      else {
        setHoldCancelComment("");
        setCanSaveHoldCancelComment(false);
      }
    }

    if (field === 'risk_label_comment') {
      if (comment && comment !== riskLabelComment) {
        setRiskLabelComment(comment);
        setCanSaveRiskLabelComment(true);
      }
      else {
        setRiskLabelComment("");
        setCanSaveRiskLabelComment(false);
      }
    }
  };

  const handleClickEditRiskLabelComment = () => {
    setOpenRiskLabelCommentDialog(true);
  };

  const onClickEditStatus = (e) => {
    setOpenOnHoldCommentDialog(true);
  }

  const disabled = () => {
    return !canEditInitiative(initiativeTeam);
  };

  const updateForOwner = () => {
    getData('/initiatives/' + params.id + '/team', setInitiativeTeam, onError);
  };

  const getNewUserCards = () => {
    if (disabled()) {
      return '';
    }
    const users = initiativeTeam.filter(item => item.role === 'Owner' || item.role === 'Editor' || item.role === 'Viewer');
    const newUsers = 6 - users.length;

    if (newUsers > 0) {
      const cards = [];

      for (let index = users.length; index < 6; index++) {
        cards.push(<AddUserCard key={'user-card-new-' + index}
          updateForOwner={updateForOwner}
          teamMembers={initiativeTeam}
          addTeamMethod={refreshInitiativeTeam} />)
      }
      return cards;
    } else {
      return '';
    }
  };

  // JSX
  return (
    <main className={classes.main}>
      <h1 className={classes.h1}>Initiative Details</h1>
      <div className={classes.details}>
        INITIATIVE NAME
        <EnhancedTextInput
          maxText={initiativeCard.is_historic_data ? 14000 : 255}
          changeMethod={changeInitiativeName}
          initialValue={initiativeName}
          autoFocus={true}
          disabled={!isTo(initiativeTeam) && !isWsl(initiativeTeam)}
          onBlurHandler={handleChange('initiative_name')}
        />
        <br />
        STATUS
        <Select
          id="select-outlined"
          value={calculatedStatusID}
          onChange={handleStatusChange('status_id')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            initiativeStatusList.map((list) => {
              return (
                <MenuItem value={list.id} key={'status-' + list.id}>{list.status}</MenuItem>
              )
            })
          }
        </Select>
        <br />
        <div>
          <CommentDialog openDialog={openOnHoldCommentDialog}
            title="On Hold/Cancelled Reason"
            description="Provide reason for putting the initiative on hold or cancelling"
            initialValue={holdCancelComment}
            onCancel={handleDialogCancel('hold_cancel_comment')}
            onOK={handleDialogOK('hold_cancel_comment')}
            onTextFieldChanged={handleDialogTextChanged('hold_cancel_comment')}
            canSave={canSaveHoldCancelComment}>
          </CommentDialog>
        </div>

        {onHoldOrCancelledField ?
          <span>
            <div>
              <span className={classes.holdCancelCommentLabelLeft}>ON HOLD/CANCELLED REASON </span>
              <span className={classes.holdCancelCommentSpan}>
                {holdCancelCommentText}
                <span className={classes.holdCancelEditButtonSpan}>
                  <Button onClick={onClickEditStatus} className={(!isAdmin && !isTo(initiativeTeam) && !isWsl(initiativeTeam)) ? classes.hideEditButton : classes.pencilButton}>
                    <BorderColorIcon />
                  </Button>
                </span>
              </span>
            </div>
            <br />
          </span>
          : null
        }

        WORKSTREAM
        <Select
          id="select-outlined"
          value={initiativeCard.workstream_id}
          onChange={handleChange('workstream_id')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            workstreamList.map((list) => {
              return (
                <MenuItem value={list.id} key={'workstream-' + list.id}>{list.name}</MenuItem>
              )
            }
            )}
        </Select>

        INITIATIVE VISIBILITY
        <Select
          id="select-outlined"
          value={initiativeCard.confidential}
          onChange={handleChange('confidential')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            Object.keys(dropdowns['InitiativeVisibility'] || {}).map(key => {
              const value = dropdowns['InitiativeVisibility'][key];
              return (<MenuItem value={key} key={'confidential-' + key}>{value}</MenuItem>);
            })
          }
        </Select>
        <Typography variant='string'>CLASSIFICATION</Typography>
        <Select
          id="select-outlined"
          value={initiativeCard.classification}
          onChange={handleChange('classification')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            Object.keys(dropdowns['InitiativeClassification'] || {}).map(key => {
              const value = dropdowns['InitiativeClassification'][key];
              return (<MenuItem value={key} key={'classification-' + key}>{value}</MenuItem>);
            })
          }
        </Select>
        <InformationBox text='COSTS BUDGETED' description={info_costs_budgeted} variant='string' />
        <Select
          id="select-outlined"
          value={initiativeCard.costs_budgeted}
          onChange={handleChange('costs_budgeted')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            Object.keys(dropdowns['InitiativeBudgeted'] || {}).map(key => {
              const value = dropdowns['InitiativeBudgeted'][key];
              return (<MenuItem value={key} key={'cost_budgeted-' + key}>{value}</MenuItem>);
            })
          }
        </Select>
        <InformationBox text='BENEFITS BUDGETED' description={info_benefits_budgeted} variant='string' />
        <Select
          id="select-outlined"
          value={initiativeCard.benefits_budgeted}
          onChange={handleChange('benefits_budgeted')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            Object.keys(dropdowns['InitiativeBudgeted'] || {}).map(key => {
              const value = dropdowns['InitiativeBudgeted'][key];
              return (<MenuItem value={key} key={'benefits_budgeted-' + key}>{value}</MenuItem>);
            })
          }
        </Select>
        <InformationBox text='INITIATIVE TYPE' description={info_initiative_type} variant='string' />
        <Select
          id="select-outlined"
          value={initiativeCard.type_id}
          onChange={handleChange('type_id')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            Object.keys(dropdowns['InitiativeType'] || {}).map(key => {
              const value = dropdowns['InitiativeType'][key];
              return (<MenuItem value={key} key={'type_id-' + key}>{value}</MenuItem>);
            })
          }
        </Select>
        RISK
        <Select
          id="select-outlined"
          value={initiativeCard.risk_label_id}
          onChange={handleRiskLabelChange('risk_label_id')}
          className={classes.inputStyle}
          disabled={disabled()}
          autoWidth={true}
        >
          {
            riskLabelOptions.map(o => {
              return (<MenuItem value={o.key} key={'type_id-' + o.key}>{o.value}</MenuItem>);
            })
          }
        </Select>
        <br />
        <div>
          <CommentDialog openDialog={openRiskLabelCommentDialog}
            title="Medium/High Risk"
            description="Provide more details for the identified risk"
            initialValue={riskLabelComment}
            onCancel={handleDialogCancel('risk_label_comment')}
            onOK={handleDialogOK('risk_label_comment')}
            onTextFieldChanged={handleDialogTextChanged('risk_label_comment')}
            canSave={canSaveRiskLabelComment}>
          </CommentDialog>
        </div>
        {showRiskComment ?
          <span>
            <div>
              <span className={classes.holdCancelCommentLabelLeft}>MEDIUM/HIGH RISK </span>
              <span className={classes.holdCancelCommentSpan}>
                {riskCommentText}
                {!disabled() &&
                  <span className={classes.holdCancelEditButtonSpan}>
                    <Button onClick={handleClickEditRiskLabelComment}
                      className={classes.pencilButton} >
                      <BorderColorIcon />
                    </Button>
                  </span>
                }
              </span>
            </div>
            <br />
          </span>
          : null
        }
      </div>
      {/* <h1 className={classes.h1}>Initiative Team</h1> */}
      <InformationBox text='Initiative Team' description={info_initiative_team} variant={'h5'} />
      <div className={classes.usersBox}>
        {initiativeTeam.filter(user => user.role === 'Owner').map(user => {
          return <AddUserCard user={user}
            teamMembers={initiativeTeam}
            addTeamMethod={refreshInitiativeTeam}
            disabled={disabled()}
            key={'user-card-' + user.initiativeUserId}
            updateForOwner={updateForOwner} />
        })}
        {initiativeTeam.filter(user => user.role === 'Editor').map(user => {
          return <AddUserCard user={user}
            teamMembers={initiativeTeam}
            addTeamMethod={refreshInitiativeTeam}
            disabled={disabled()}
            key={'user-card-' + user.initiativeUserId}
            updateForOwner={updateForOwner} />
        })}
        {initiativeTeam.filter(user => user.role === 'Viewer').map(user => {
          return <AddUserCard user={user}
            teamMembers={initiativeTeam}
            addTeamMethod={refreshInitiativeTeam}
            disabled={disabled()}
            key={'user-card-' + user.initiativeUserId}
            updateForOwner={updateForOwner} />
        })}
        {getNewUserCards()}
      </div>
      <div className={classes.usersBox}>
        {initiativeCard.historic_formated_text ?
          <HistoricData historic_formated_text={initiativeCard.historic_formated_text} /> :
          ''}
      </div>
    </main>
  );
}
